import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { UiComponents } from "@simulanisindia/ui";
import BtnLoad from "../common/BtnLoad";
import { AddProjectLightIcon } from "../../Assest/icons/icons";
const { SimInputBar } = UiComponents;

const AddProject = ({ handleClose, show, onAdd = async () => {} }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [error, setError] = useState({ name: "" });

  const closeModal = () => {
    setLoading(false);
    if (typeof handleClose === "function") {
      handleClose();
    }
  };

  const payloadInvalid = () => {
    if (!name) {
      setError((prev) => ({ ...prev, name: "Name is Required For Module Creation" }));
      return true;
    }
    return false;
  };

  const onChange = (key, value) => {
    if (key == "name") {
      setName(() => value);
      setError((prev) => ({ ...prev, name: "" }));
    }
  };

  const handleOnAdd = async () => {
    if (loading || payloadInvalid()) return;
    setLoading(true);
    await onAdd({ name });
    setLoading(false);
    closeModal();
  };

  const init = () => {
    setName("");
    setError({ name: "" });
  };
  useEffect(() => {
    show && init();
  }, [show]);

  return (
    <>
      <Modal show={show} centered onHide={closeModal} className="createModal">
        <div className="customModalHead">
          <div className="filterbtn">
            <div className="btninadjust">
              <AddProjectLightIcon />
            </div>
          </div>
          <h6>Add Project</h6>
        </div>
        <Modal.Body>
          <div className="projectCreation">
            <div className="inputItem">
              <p>Project Name</p>
              <SimInputBar placeholder="Name" value={name} onChange={(e) => onChange("name", e.target.value)} />
              {!!error.name && <p className="small text-muted px-1">{error.name}</p>}
            </div>
          </div>
        </Modal.Body>
        <div className="modalFooterB">
          <button className="cancel" onClick={closeModal}>
            Close
          </button>
          <button className="save" onClick={handleOnAdd}>
            {loading ? <BtnLoad /> : "Add"}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AddProject;
